/**
 * Set `--app-height` variable to `:root` for use in CSS
 */
export function appHeight() {
    const doc = document.documentElement;
    // Используем визуальный viewport если доступен (лучше для мобилок)
    const height = window.visualViewport 
        ? window.visualViewport.height 
        : window.innerHeight;
    doc.style.setProperty('--app-height', `${height}px`);
};

// Debounce функция для оптимизации
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// Обработчик с debounce
const debouncedAppHeight = debounce(appHeight, 100);

// Add resize listener to change value
window.addEventListener('resize', debouncedAppHeight);

// Также слушаем orientationchange для мобилок
window.addEventListener('orientationchange', () => {
    // Небольшая задержка для корректного получения новой высоты
    setTimeout(appHeight, 100);
});

// Слушаем Visual Viewport API если поддерживается
if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', debouncedAppHeight);
}

// Set value once when loaded
appHeight();

// Обновляем при загрузке страницы (для корректной инициализации)
window.addEventListener('load', appHeight);
